import styled from "@emotion/styled";

export const StyledColumn = styled.div`
  border: 2px solid ${({ theme }) => theme.colors.main[7]};
  padding: 10px;
`;
export const StyledColumnDroppable = styled.div<{ isDraggingOver: boolean }>`
  background: ${({ isDraggingOver, theme }) =>
    isDraggingOver ? theme.colors.main[2] : theme.colors.tdBackgroundColor};
  padding: 4px;
  width: 250px;
  min-height: 500px;
`;
